import React, { Component } from 'react'
import { withPrefix } from 'gatsby-link'
import Img from 'gatsby-image'

import './card.css'

class Card extends Component {

  render () {
    let data = this.props.data;
    let img = <Img className="card-img" sizes = {this.props.sizes}></Img>
    let cardImg = data.isClickable ? <a target="_blank" href={data.href}>{img}</a> : <div>{img}</div>;

    return (
      <div className={"card" + (this.props.isShort ? " short" : " tall")}>
        {cardImg}
        <div className="card-content">
          <div className="card-name">
            {data.name}
          </div>
          <div className="card-info">
            <div className="card-info-block">
              <div style={{lineHeight: 1.5}}>
                {data.position}
              </div>
            </div>
            <div className="card-info-block">
              <div style={{lineHeight: 1.5}}>
                {data.affiliation}
              </div>
            </div>
            <div className="card-info-block">
              <div style={{lineHeight: 1.5}}>
                {data.affiliate_position}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default {Card}



// WEBPACK FOOTER //
// ./src/components/Card/index.js